import React from 'react';
import {observer} from 'mobx-react-lite';

import VideoListCard from '../../components/Video/VideoListCard';

export default observer(({videos}: any) => {
  return videos.map(v => <VideoListCard video={v} referrer="purchases page" />);
});
